import API from './api';
import CachedApi from './cachedApi';
import { Urls } from './urls';

const NOTIFICATIONS_COUNT_CACHE_DURATION = 15 * 60 * 1000; // 15 minutes

export const NotificationsService = {
    getNotifications: function (params) {
        return API.get(Urls.ApiNotification, { params: params });
    },

    getNotificationsCount: function () {
        return CachedApi.get(
            Urls.ApiNotification + 'unread_count',
            {},
            { cacheDuration: NOTIFICATIONS_COUNT_CACHE_DURATION }
        );
    },
}
